import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconOptionCatalog(props: SvgIconProps) {
  return (
    <SVGIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.6875 21C1.30781 21 1 20.6217 1 20.1538V2.8462C1 2.3791 1.30781 2 1.6875 2H22.3125C22.6921 2 23 2.3791 23 2.8462V20.1538C23 20.6217 22.6921 21 22.3125 21H1.6875ZM2.375 9V14H6.5V9H2.375ZM2.375 15V20H6.5V15H2.375ZM7.875 15V20H21.625V15H7.875ZM21.625 9V14H7.875V9H21.625ZM2.375 3V8H6.5V3H2.375ZM21.625 3V8H7.875V3H21.625Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        xmlns="http://www.w3.org/2000/svg"
      />
    </SVGIcon>
  );
}
